<p-toast></p-toast>
<div class="bpt-main-content-containerForSession">
    <div *ngIf="courseDetails.courseAuthorizationFlags.isEditButtonAvailable && !isCourseInactive">
        <p-button appPreventDoubleClick pTooltip="Add Session" tooltipPosition="left" icon="fa fa-plus"
            id="addSessionBtn" class="add-session-button" iconPos="left"
            (debounceClick)="openSessionSlider()"></p-button>
    </div>
    <app-panel-hub [config]="panelHubConfig" (panelHubStateChanged)="onPanelHubStateChanged($event)"
        *ngIf="isSessionManagementDataAvailable"
        [pagedData]="pagedData" (panelEventHub)="onPanelEventHubInitialized($event)" class="session-panel">
        
        <!-- Content Template - Session details display -->
        <ng-template #contentTemplate let-data="dataVar">
            <div panel-content>
                <div class="grid">
                    <div class="col1">
                        <div class="fields-row">
                            <div class="sessionColumn1">
                                <app-label labelText="{{ 'Date & Time'}}"></app-label>
                                <app-read-only [readonlyText]="setDateTime(data)"></app-read-only>
                            </div>
                            <div class="sessionColumn2 overflow-ellipsis">
                                <app-label labelText="{{ 'Trainer(s)'}}"></app-label>
                                <div class="text-container overflow-ellipsis">
                                    <div *ngFor="let trainer of data?.trainers">
                                        {{trainer.isactive}}
                                        <app-read-only
                                            [ngClass]="{'inactive':trainer.isActive===false || trainer.isTerminated === true}"
                                            readonlyText="{{ trainer.assignedUserName}}"
                                            toolTipMessage="{{trainer.assignedUserName}}"></app-read-only>
                                    </div>
                                </div>
                            </div>
                            <div class="column3 notesCol overflow-ellipsis">
                                <app-label labelText="{{ 'Format'}}"></app-label>
                                <app-read-only readonlyText="{{data?.format}}"></app-read-only>
                            </div>
                            <div class="column4 overflow-ellipsis">
                                <app-label labelText="{{ 'Virtual Meeting URL'}}"></app-label>
                                &nbsp;
                                <div class="grid" *ngIf="data?.virtualMeetingURL!=='N/A'">
                                    <div class="col max-w-0 pl-1"><em
                                            class="pi pi-external-link blue-color cursor-pointer vitrual-Meeting-URL-Button"
                                            (click)="OpenVirtualMeeting(data?.virtualMeetingURL)"></em></div>
                                </div>
                                <div *ngIf="data?.virtualMeetingURL==='N/A'">
                                    <app-read-only readonlyText="N/A"></app-read-only>
                                </div>
                            </div>
                            <div class="column3">
                                <app-label labelText="{{ 'Attachments'}}"></app-label>
                                <div *ngIf="data?.attachments !==null && data?.attachments.length > 0"
                                    class="col max-w-0 pl-1">
                                    <em class="pi pi-paperclip blue-color cursor-pointer"
                                        (click)="OpenDocumentAttachmentModal(data?.sessionId)">
                                    </em>
                                </div>
                                <div *ngIf="data?.attachments === null || data?.attachments.length === 0"
                                    class="col max-w-0 pl-1 attachmentColumn">
                                    <app-read-only readonlyText="N/A"></app-read-only>
                                </div>
                            </div>

                            <div class="column5">
                                <app-speed-dial [menuItemsData]="data.speedDialOptions"></app-speed-dial>
                            </div>
                        </div>
                    </div>
                    <div class="fields-row">
                        <div class="sessionColumn1">
                            <app-label labelText="{{ 'Status'}}"></app-label>
                            <div class="grid pt-1 session-status">
                                <div class="col max-w-0 pb-0">
                                    <em class="pi pi-circle-fill ml-1 mr-1 mt-1"
                                        [ngClass]="calculateStatusColor(data?.status)"></em>
                                </div>
                                <div class="col ml-2 pb-0">
                                    <app-read-only readonlyText="{{data?.status}}"></app-read-only>
                                </div>
                            </div>
                        </div>
                        <div class="sessionColumn2">
                            <app-label labelText="{{ 'Enrollment'}}"></app-label>
                            <div class="grid pt-1 session-enrollment">
                                <div class="col max-w-0 pb-0">
                                    <em class="pi pi-circle-fill ml-1 mr-1 mt-1"
                                        [ngClass]="calculateEnrollmentColor(data?.enrollment)"></em>
                                </div>
                                <div class="col ml-2 pb-0">
                                    <app-read-only readonlyText="{{data?.enrollment}}"></app-read-only>
                                </div>
                            </div>
                        </div>
                        <div class="column3 session-attendee">
                            <div [ngClass]="calculateAttendeeColor(data?.enrolledAttendees, data?.enrollment)">
                                <app-label labelText="{{ 'Attendees'}}"></app-label>
                                <app-read-only readonlyText="{{data?.attendees}}"></app-read-only>
                            </div>
                        </div>
                        <div class="column3 overflow-ellipsis">
                            <app-label labelText="{{ 'Room'}}"></app-label>
                            <div class="text-container overflow-ellipsis">
                                <app-read-only readonlyText="{{data?.room}}"
                                    toolTipMessage="{{data?.room}}"></app-read-only>
                            </div>
                        </div>
                        <div class="column4">
                        </div>
                        <div class="column5">
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
    </app-panel-hub>
    <div class="displayCenter"
        *ngIf="!showLoader && (!pagedData || pagedData.data.length === 0) && !isSessionManagementDataAvailable">
        <app-empty-results></app-empty-results>
    </div>

</div>
<app-session-slider *ngIf="isSessionSliderOpen" [isAddSessionSliderOpen]="isSessionSliderOpen"
    [sessionId]="courseSessionId" [courseDetailsData]="courseDetails"
    (isSessionManagementDataReload)="sessionManagementDataReload($event)">
</app-session-slider>

<app-session-attendee *ngIf="isSessionAttendeeSliderOpen" [isSessionAttendeeSliderOpen]="isSessionAttendeeSliderOpen"
    [SliderHeader]="sliderAttendeeHeaderText" (isSessionAttendeeSliderActive)="closeSessionAttendeeSlider($event)"
    [sessionId]="[courseSessionId]" [minimumPassingScore]="minimumPassingScore" [ScoringOption]="ScoringOption"
    [ProficiencyQuiz]="ProficiencyQuiz" [courseNumber]="courseDetails.courseNumber">
</app-session-attendee>

<app-session-attachments (attachmentsPopupVisible)="openAttachmentModal($event)"
    [openAttachmentModal]="attachmentsAvailable" [attachmentsData]="sessionAttachments"> </app-session-attachments>

<app-session-audit-modal *ngIf="showSessionAuditModal" [sessionId]="sessionIdForAudit"
    [isSessionAuditModalShow]="showSessionAuditModal" (showSessionAuditModal)="closeSessionAuditModal($event)">
</app-session-audit-modal>
